import { useState } from 'react';
import CardContent from 'components/Base/Layout/Content/CardContent';
import { TabBodyWrapper } from 'components/Base/Tabs';
import { useGetInKindSummaryQuery } from 'redux/apiSlice/inKind.slice';
import { TInKindView } from './InKindTab.types';
import YearSummary from './YearSummary';
import QuarterDetail from './QuarterDetail';

const CURRENT_YEAR = new Date().getFullYear();

const InKindTab = ({ elcId }: { elcId: string }) => {
  const [selectedYear, setSelectedYear] = useState<number>(CURRENT_YEAR);
  const [view, setView] = useState<TInKindView>({ mode: 'year' });

  const { data, isLoading } = useGetInKindSummaryQuery({
    elcId,
    year: selectedYear,
  });

  const handleQuarterClick = (quarter: number) => {
    setView({ mode: 'quarter', quarter });
  };

  const handleBackToYear = () => {
    setView({ mode: 'year' });
  };

  const handleYearChange = (year: number) => {
    setSelectedYear(year);
    setView({ mode: 'year' });
  };

  return (
    <CardContent tabContent contentPadding="0">
      <TabBodyWrapper>
        {view.mode === 'year' ? (
          <YearSummary
            elcId={elcId}
            selectedYear={selectedYear}
            data={data}
            isLoading={isLoading}
            onYearChange={handleYearChange}
            onQuarterClick={handleQuarterClick}
          />
        ) : (
          <QuarterDetail
            elcId={elcId}
            selectedYear={selectedYear}
            selectedQuarter={view.quarter}
            onBack={handleBackToYear}
          />
        )}
      </TabBodyWrapper>
    </CardContent>
  );
};

export default InKindTab;
